import React, { useState, } from "react";
import { FormattedMessage, } from "react-intl";
import { PenIcon, UsersThreeIcon, UserMinusIcon, CheckCircleIcon, XCircleIcon, } from "@phosphor-icons/react";

import MomentWrapper from "../../helpers/moment.wrapper";
import 'moment-timezone';
import Gravatar from 'react-gravatar';
import { Table, Row, Button, Col, Tag, Tooltip, Avatar, } from 'antd';
import { EditUserModal, DeleteUserModal, } from '../index';

const UserGridView = ({
    dataLoading = true,
    dataTable,
    refreshData,
    history,
    ...props
}) => {

    // modals
    const [editUserModalOpen, setEditUserModalOpen] = useState(false);
    const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);
    const [userProfileData, setUserProfileData] = useState({});

    // Get current user details
    const localdata = sessionStorage.getItem('authentication');
    const idToken = JSON.parse(localdata);
    const { username, } = idToken;

    const editUserModalHandler = (data) => {
        setUserProfileData(data);
        setEditUserModalOpen(true);
    };

    const deleteUserModalHandler = (data) => {
        setUserProfileData(data);
        setDeleteUserModalOpen(true);
    };

    const columns = [
        {
            title: <FormattedMessage id="username" />,
            dataIndex: 'user_email',
            key: 'user_email',
            render: (user_email, record) => (
                <Row align="middle" justify="space-around">
                    <Col span={5}>
                        <Avatar size="large" icon={<Gravatar email={user_email} default="robohash" className="rounded-full" />} />

                    </Col>
                    <Col span={17} className="ml-2">
                        <div className="font-weight-bolder">{record.user_data?.user_first_name} {record.user_data.user_last_name}</div>
                        <div className="font-weight-light">{user_email}</div>
                    </Col>
                </Row>
            )
        },
        {
            title: <FormattedMessage id="registration-date" />,
            dataIndex: 'user_created',
            key: 'user_created',
            render: user_created => (<MomentWrapper tz="Europe/Amsterdam" format="DD-MM-YYYY" date={user_created} />),
        },
        {
            title: <FormattedMessage id="status" />,
            dataIndex: 'user_status',
            key: 'user_status',
            align: 'center',
            render: user_status => (
                <Tag color={user_status === 'ACTIVE' ? 'green' : 'volcano'}>{ } {user_status.toUpperCase()}</Tag>
            )
        },
        {
            title: <FormattedMessage id="permission-group" />,
            dataIndex: 'user_data',
            key: 'user_data',
            align: 'center',
            render: user_data => (
                <>
                    <Tag><UsersThreeIcon size={16} weight="light" /> {user_data.user_group}</Tag>
                </>
            )
        },
        {
            title: 'MFA',
            dataIndex: 'user_mfa_enabled',
            key: 'user_mfa_enabled',
            align: 'center',
            render: user_mfa_enabled => (
                <>
                    <Tag color={user_mfa_enabled ? 'green' : 'volcano'}>
                        {user_mfa_enabled ?
                            <CheckCircleIcon color="green" size={16} weight="light" />
                            :
                            <XCircleIcon color="red" size={16} weight="light" />
                        }
                    </Tag>
                </>
            )
        },
        {
            title: 'IP Validation',
            dataIndex: 'user_ip_validation_disabled',
            key: 'user_ip_validation_disabled',
            align: 'center',
            render: user_ip_validation_disabled => (
                <>
                    <Tag color={!user_ip_validation_disabled ? 'green' : 'volcano'}>
                        {!user_ip_validation_disabled ?
                            <CheckCircleIcon color="green" size={16} weight="light" />
                            :
                            <XCircleIcon color="red" size={16} weight="light" />
                        }
                    </Tag>
                </>
            )
        },
        {
            title: "",
            dataIndex: "button",
            key: "button",
            align: 'center',
            render: (button, record) => (
                <>
                    <Tooltip placement="top" title={<FormattedMessage id="edit-user-open-tt" />}>
                        <Button
                            icon={<PenIcon size={16} weight="light" />}
                            size="small"
                            onClick={(e) => {
                                if (username === record.cognito_user_id) {
                                    history('/profile/me');
                                } else {
                                    editUserModalHandler(record);
                                }
                            }}
                            className="mr-1"
                        />
                    </Tooltip>
                    <Tooltip placement="top" title={<FormattedMessage id="delete-user-open-tt" />}>
                        <Button
                            hidden={username === record.cognito_user_id}
                            type="primary"
                            danger
                            icon={<UserMinusIcon size={16} weight="light" />}
                            size="small"
                            onClick={(e) => { deleteUserModalHandler(record); e.stopPropagation(); }}
                            className="mr-1"
                        />
                    </Tooltip>
                </>
            )
        }
    ];

    return (
        <React.Fragment>

            <Table
                rowKey={record => record.user_id}
                dataSource={dataTable}
                columns={columns}
                loading={dataLoading}
                pagination={{ pageSize: 500 }}
                rowClassName="pointer"
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => { editUserModalHandler(record) }, // click row
                        onDoubleClick: event => { }, // double click row
                        onContextMenu: event => { }, // right button click row
                        onMouseEnter: event => { }, // mouse enter row
                        onMouseLeave: event => { }, // mouse leave row
                    };
                }}

            />

            {editUserModalOpen && (
                <EditUserModal
                    modalIsOpen={editUserModalOpen}
                    modalIsOpenHandler={setEditUserModalOpen}
                    userProfileData={userProfileData}
                    refreshData={refreshData}
                    history={history}
                    {...props}
                />
            )}

            {deleteUserModalOpen && (
                <DeleteUserModal
                    modalIsOpen={deleteUserModalOpen}
                    modalIsOpenHandler={setDeleteUserModalOpen}
                    userProfileData={userProfileData}
                    refreshData={refreshData}
                    history={history} />
            )}

        </React.Fragment>

    );
};

export default UserGridView;